// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__1lBf7","carouselItem":"styles_carouselItem__3gJgH","carouselCaption":"styles_carouselCaption__16GRp","carouselImage":"styles_carouselImage__1xuQb"};